export default __webpack_public_path__ + "static/media/3 (1).dd037f4c.svg";